"use client";

import { SText } from "@/components/atoms";
import SHeading from "@/components/atoms/SHeading";
import Image from "next/image";
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { useTranslation } from "react-i18next";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import {
  partnerLogos,
  testimonials as getTestimonials,
} from "@/constants/values";

const Testimonials = () => {
  const { t } = useTranslation();
  const testimonials = getTestimonials(t);

  return (
    <div className="bg-gray-100 py-20">
      <SHeading
        text={t("testimonials.title1")}
        className="flex justify-center font-bold md:text-3xl text-xl mb-8"
      />
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-10 max-w-6xl mx-auto pb-8">
        {partnerLogos.map((logo, index) => (
          <div
            key={`partnerLogo-${index}`}
            className="flex justify-center items-center flex-1"
          >
            <Image
              src={logo.src}
              width={132}
              height={132}
              alt={logo.alt}
              className="object-cover"
            />
          </div>
        ))}
      </div>

      <SHeading
        text={t("testimonials.title2")}
        className="flex justify-center font-bold md:text-3xl text-xl my-8"
      />
      <div className="container mx-auto">
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          navigation
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          pagination={{ clickable: true }}
          spaceBetween={30}
          slidesPerView={3}
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          }}
          className="custom-swiper"
        >
          {testimonials.map((testimonial, index) => (
            <SwiperSlide key={`testimonial-${index}`}>
              <div className="bg-white p-6 rounded-lg shadow-md min-h-[424px] h-full">
                <Image
                  src={testimonial.image}
                  width={300}
                  height={200}
                  alt={""}
                  className="w-full h-48 object-cover rounded-lg mb-4"
                />
                <SText text={testimonial.text} className="text-gray-700" />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Testimonials;
